var u = Object.defineProperty, m = Object.defineProperties;
var h = Object.getOwnPropertyDescriptors;
var c = Object.getOwnPropertySymbols;
var R = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var f = (t, e, n) => e in t ? u(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, s = (t, e) => {
  for (var n in e || (e = {}))
    R.call(e, n) && f(t, n, e[n]);
  if (c)
    for (var n of c(e))
      p.call(e, n) && f(t, n, e[n]);
  return t;
}, d = (t, e) => m(t, h(e));
import { jsx as a } from "react/jsx-runtime";
import { useState as y, useEffect as E } from "react";
import { components as w } from "react-select";
function M(t) {
  const [e, n] = y(null), {
    selectProps: l
  } = t, {
    parentRef: o
  } = l;
  return E(() => {
    if (e) {
      const r = o || document.body, g = r.getBoundingClientRect(), i = e.getBoundingClientRect();
      (r === document.body ? window.innerWidth < i.right : g.right < i.left + i.width) ? e.style.right = "0" : e.style.left = "0";
    }
  }, [e, o]), /* @__PURE__ */ a(w.Menu, d(s({}, t), { innerRef: n, innerProps: t.innerProps, children: t.children }));
}
export {
  M as Menu
};
//# sourceMappingURL=Menu.es.js.map
